export type PromptChoice = { title: string; prompt: string; images?: string[]; };

type PromptPresetDef = {
  title: string;
  prompt: string;
  imageCount?: number;
};

function buildPresets(field: string, defs: PromptPresetDef[]): PromptChoice[] {
  return defs.map(d => {
    let images: string[] = [];
    if (d.imageCount && d.imageCount > 0) {
      const slug = slugify(d.title);
      images = Array.from({ length: d.imageCount }, (_, i) =>
        `/static/images/diffsona-from-description/${field}/${slug}/${i + 1}.webp`
      );
    }
    return { title: d.title, prompt: d.prompt, images };
  });
}

export const DiffsonaFromDescriptionPresets = {
    base: buildPresets('base', [
      { title: 'Fashion Editorial', prompt: 'high-fashion editorial, studio lighting, crisp', imageCount: 15 },
      { title: 'Street Style', prompt: 'urban street style, candid, natural light', imageCount: 7 },
      { title: 'Fantasy Hero', prompt: 'epic fantasy, heroic, dramatic rim light', imageCount: 8 },
      { title: 'Cyberpunk', prompt: 'neon cyberpunk, moody, rain-soaked city', imageCount: 3 },
    ]),

    age: buildPresets('age', [
      //{ title: 'Teen', prompt: 'teenage' },
      { title: '20s', prompt: 'in their twenties', imageCount: 15 },
      { title: '30s', prompt: 'in their thirties', imageCount: 6 },
      { title: '40s+', prompt: 'mature adult', imageCount: 13 },
    ]),

    ethnicity: buildPresets('ethnicity', [
      { title: 'Latina', prompt: 'Latina' },
      { title: 'Black', prompt: 'Black' },
      { title: 'Korean', prompt: 'Korean' },
      { title: 'South Asian', prompt: 'South Asian' },
      { title: 'White', prompt: 'White' },
      { title: 'Mixed', prompt: 'mixed heritage' },
      { title: 'Japanese', prompt: 'Japanese' },
      { title: 'Lebanese', prompt: 'Lebanese' },
    ]),

    hair: buildPresets('hair', [
      { title: 'Long Wavy', prompt: 'long wavy hair', imageCount: 3 },
      { title: 'Bob Black', prompt: 'black bob', imageCount: 2 },
      { title: 'Curly Red', prompt: 'curly red hair', imageCount: 2 },
      { title: 'Black Hair', prompt: 'black hair', imageCount: 2 },
    ]),

    face: buildPresets('face', [
      { title: 'Soft & Natural', prompt: 'soft features, minimal makeup' },
      { title: 'Sharp & Defined', prompt: 'defined cheekbones, sharp jawline' },
      { title: 'Freckles', prompt: 'light freckles' },
      { title: 'Glam', prompt: 'glam makeup, glossy lips' },
    ]),

    body: buildPresets('body', [
      { title: 'Athletic', prompt: 'athletic build' },
      { title: 'Slim', prompt: 'slim build' },
      { title: 'Curvy', prompt: 'curvy build' },
      { title: 'Tall', prompt: 'tall build' },
      //{ title: 'Toned', prompt: 'toned physique' },
      //{ title: 'Muscular', prompt: 'muscular build' },
      { title: 'Average', prompt: 'average build' },
      { title: 'Hourglass', prompt: 'hourglass figure' },
      //{ title: 'Pear-shaped', prompt: 'pear-shaped body' },
      //{ title: 'Petite',        prompt: 'petite build' },
    ]),

    bust: buildPresets('bust', [
      { title: 'Small bust', prompt: 'small bust' },
      { title: 'Medium bust', prompt: 'medium bust' },
      { title: 'Full bust', prompt: 'full bust' },
    ]),

    waist: buildPresets('waist', [
      { title: 'Narrow waist', prompt: 'narrow waist' },
      { title: 'Defined waist', prompt: 'defined waist' },
      { title: 'Natural waist', prompt: 'natural waist' },
    ]),

    hips: buildPresets('hips', [
      { title: 'Slim hips', prompt: 'slim hips' },
      { title: 'Curvy hips', prompt: 'curvy hips' },
      { title: 'Wide hips', prompt: 'wide hips' },
    ]),
  }

function slugify(s: string): string {
  return s.toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')   // replace non-alphanum with dashes
    .replace(/^-+|-+$/g, '');      // trim leading/trailing dashes
}

